<template>
  <div class="pages">
    <div class="txt">正在前往微信支付中...</div>
  </div>
</template>
<script>
import config from '@/config/index'
export default {
  data () {
    return {
      produtId : '',
      playerId : '',
      rechargeType : 0,
      extend : '',
      orderId: '',
      appid : 'wxaf3075e250b6d308',
    }
  },
  created () {
    this.produtId = this.$route.query.goodId||'';
    this.playerId = this.$route.query.playerId || ''
    this.rechargeType = this.$route.query.rechargeType || 0;
    this.extend = this.$route.query.extend || '';
    this.orderId = this.$route.query.orderId || '';
    if(this.$route.query.appid){
      this.appid = this.$route.query.appid || '';
    }
    
    this.getData()
  },

  methods : {
    async getData(){
      let d = {
        productId : this.produtId,
        xyUserId : this.playerId,
        attach : this.rechargeType,
        extend : this.extend,
        orderId : this.orderId,
        appid : this.appid
      }
      let baseUrl = `${config.redirectUrl}/#/paysend`
      let res = await this.$api.user.createH5Order(d)
      if(res.data.code == 200){
        let url = res.data.data;
        
        if(url){
          baseUrl = encodeURIComponent(baseUrl)
          url = url + `&redirect_url=${baseUrl}`
          // console.log(url)
          window.location.href = url;
        }
      }
    }
  }
  
}
</script>

<style scoped lang="less">
  .pages{
    min-height: 100%;
    display:  flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;

  }
  .txt{
    font-size: 16px;
  }
</style>
